import ModalRedReceiptDetail from "./ModalRedReceiptDetail";

export default ModalRedReceiptDetail;
